<template>
  <div class="add_tklist">
    <yd-cell-group v-for="(field,index) in fields" :key="index">
      <yd-cell-group v-if="field.field_name === 'province'">
        <yd-flexbox>
          <yd-flexbox-item>
            <yd-cell-group>
              <yd-cell-item arrow>
                <span slot="left"><b style="color:red" v-if="field.required === '1'">*</b>省市县：</span>
                <input slot="right" type="text" @click.stop="cityShow = true" v-model="pcd" readonly
                       placeholder="请选择收货地址">
              </yd-cell-item>
            </yd-cell-group>
            <yd-cityselect v-model="cityShow"
                           :callback="result1"
                           :provance="fieldsData_1.province"
                           :city="fieldsData_1.city"
                           :area="fieldsData_1.area"
                           :items="district"
            ></yd-cityselect>
          </yd-flexbox-item>
        </yd-flexbox>
      </yd-cell-group>
      <div v-else-if="field.field_name === 'city' || field.field_name === 'area'"></div>
      <yd-cell-item v-else-if="field.field_type === 'system' || field.field_type === 'text'">
        <span slot="left"><b style="color:red" v-if="field.required === '1'">*</b>{{ field.field_des }}：</span>
        <input slot="right" type="text" v-model="fieldsData_1[field.field_name]" :placeholder="field.remind"
               @change="updateFieldsData">
      </yd-cell-item>
      <div class="yd-cell-item" v-else-if="field.field_type === 'radio'">
        <div class="yd-cell-left"><b style="color:red" v-if="field.required === '1'">*</b>{{ field.field_des }}：</div>
        <div class="yd-cell-right" v-for="(radio,index) in field.child" :key="index">
          <input type="radio" :name="field.tablename + field.field_name" v-model="fieldsData_1[field.field_name]"
                 :value="index" @change="updateFieldsData">{{ radio }}
        </div>
      </div>
      <div class="yd-cell-item" v-else-if="field.field_type === 'checkbox'" v-model="fieldsData_1[field.field_name]">
        <div class="yd-cell-left"><b style="color:red" v-if="field.required === '1'">*</b>{{ field.field_des }}：</div>
        <div class="yd-cell-right add_checkbox" v-for="(radio,index) in field.child" :key="index">
          <input type="checkbox" v-model="fieldsData_1[field.field_name]" :name="field.tablename + field.field_name"
                 :value="index"
                 @change="updateFieldsData">{{ radio }}
        </div>
      </div>
      <div class="yd-cell-item" v-else-if="field.field_type === 'select'">
        <div class="yd-cell-left"><b style="color:red" v-if="field.required === '1'">*</b>{{ field.field_des }}：</div>
        <div class="yd-cell-right">
          <select name="" v-model="fieldsData_1[field.field_name]" @change="updateFieldsData">
            <option value="">请选择</option>
            <option v-for="(select,index) in field.child" :key="index" :value="index">{{ select }}</option>
          </select>
        </div>
      </div>
      <div class="yd-cell-item" v-else-if="field.field_type === 'img'">
        <div class="yd-cell-left"><b style="color:red" v-if="field.required === '1'">*</b>{{ field.field_des }}：</div>
        <div class="yd-cell-right">
          <input type="file" :name="field.field_name" @change="fileUpload">
        </div>
      </div>
      <div class="yd-cell-item" v-else-if="field.field_type === 'date'">
        <div class="yd-cell-left"><b style="color:red" v-if="field.required === '1'">*</b>{{ field.field_des }}：</div>
        <div class="yd-cell-right">
          <input type="date" v-model="fieldsData_1[field.field_name]" @change="updateFieldsData">
        </div>
      </div>
    </yd-cell-group>
  </div>
</template>

<script type="text/babel">
import Vue from 'vue'
import axios from 'axios'
import {CitySelect} from 'vue-ydui/dist/lib.rem/cityselect'
import District from 'assets/js/city'

Vue.component(CitySelect.name, CitySelect)
export default {
  name: 'cell',
  props: ['fieldsData', 'fields'],
  data() {
    return {
      district: District,
      pcd: '',
      cityShow: false,
      fieldsData_1: this.fieldsData
    }
  },
  methods: {
    result1(ret) {
      this.pcd = ret.itemName1 + ' ' + ret.itemName2 + ' ' + ret.itemName3
      this.fieldsData_1.province = ret.itemValue1
      this.fieldsData_1.city = ret.itemValue2
      this.fieldsData_1.area = ret.itemValue3
      this.$emit('refreshData', 'fieldsData', this.fieldsData_1)
    },
    updatepcd() { // 默认地址、 赋值
      let p = ''
      let c = ''
      let d = ''
      District.forEach(item => {
        if (item.v === this.province) {
          p = item.n
          item.c.forEach(itemc => {
            if (itemc.v === this.city) {
              c = itemc.n
              itemc.c.forEach(ic => {
                if (ic.v === this.area) {
                  d = ic.n
                }
              })
            }
          })
        }
      })
      this.pcd = p + ' ' + c + ' ' + d
    },
    updateFieldsData() {
      this.$emit('refreshData', 'fieldsData', this.fieldsData_1)
    },
    fileUpload(event) {
      let file = event.target.files
      let reader = new FileReader()
      reader.readAsDataURL(file[0])
      let _this = this
      reader.onload = function (e) {
        let data = {
          data: e.target.result,
          name: file[0].name
        }
        axios
          .post('/fair/file-upload', data)
          .then(res => {
            res = res.data
            if (res.status) {
              _this.$dialog.toast({mes: res.msg})
              _this.fieldsData_1[event.target.name] = res.data.id
              _this.$emit('refreshData', 'fieldsData', _this.fieldsData_1)
            } else {
              _this.$dialog.toast({mes: res.msg})
            }
          })
      }
    }
  },
  mounted() {
    this.updatepcd()
  },
  watch: {
    fieldsData_1: function () {
      this.$emit('refreshData', 'fieldsData', this.fieldsData_1)
    }
  }
}
</script>
<style lang="stylus" scoped>
.add_tklist >>> .yd-cell-right input::-webkit-input-placeholder
  color: #999
  font-size: .28rem

.add_tklist >>> .yd-cell-right input::-moz-placeholder
  color: #999
  font-size: .28rem

.add_tklist >>> .yd-cell-right input:-moz-placeholder
  color: #999
  font-size: .28rem

.add_tklist >>> .yd-cell-right input:-ms-input-placeholder
  color: #999
  font-size: .28rem

.add_tklist >>> .yd-cell-right
  min-height: .6rem

.add_tklist >>> .yd-cell-right input
  height: .6rem
  line-height: .6rem
  font-size: .28rem

.add_tklist >>> .yd-cell-right select
  height: .6rem
  line-height: .6rem
  font-size: .28rem
  appearance: menulist-button
  -webkit-appearance: menulist-button
  -moz-appearance: menulist-button
  color #555

.add_tklist .yd-cell-right.add_checkbox input[type=checkbox]:not(.yd-switch)
  position relative
  left 0
  margin-right .2rem
  width 0.3rem
  height 0.3rem
  border 1px solid #dcdcdc
  appearance none
  -webkit-appearance none

.add_tklist >>> .yd-cell-right
  justify-content left

.add_tklist .yd-cell-right.add_checkbox input[type=checkbox]:checked
  border 1px solid #1b54f5

.add_tklist .yd-cell-right.add_checkbox input[type=checkbox]:checked:after
  display block
  content ""
  position absolute
  left 0
  right -2px
  top 0
  bottom 0
  margin auto
  width .37rem
  height .3rem

.add_tklist >>> .yd-cell
  z-index 1 !important
  position inherit !important

</style>



// WEBPACK FOOTER //
// src/views/template1/compontents/cell.vue